/* global module */
module.exports = {
  methods: {

    _passwordValidation(PW1, PW2, PWMin8, PWSpecialChars) {
      console.log('_passwordValidation')
      var passwordsInfo = []
      // if (PWMin8 && (PW1.length < 8 || PW2.length < 8)) {
      //   passwordsInfo.push('Geef minstens 8 karakters op.')
      // }
      if (PW1 !== PW2) {
        passwordsInfo.push('Wachtwoorden niet identiek.')
      }
      if ((PWMin8 && (PW1.length < 8 || PW2.length < 8)) || !(this._hasSpecialCharacters(PW1) && this._hasUpperCase(PW1) && (this._hasNumber(PW1)))) {
        passwordsInfo.push('Je wachtwoord moet minstens 8 tekens lang zijn en letters, cijfers en een speciaal karakter bevatten.')
      }
      return passwordsInfo
    },

    _hasSpecialCharacters(string) {
      // eslint-disable-next-line
      var format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
      return format.test(string)
    },

    _hasUpperCase(string) {
      return (/[A-Z]/).test(string)
    },

    _hasNumber(string) {
      return /\d/.test(string);
    },

    _emailValidation(email) {
      var re = /\S+@\S+\.\S+/
      if (re.test(email)) {
        return ''
      } else {
        return 'Het e-mailadres is niet geldig.'
      }
    },

    _min1characterValidation(string) {
      if (string === null || string === undefined || string.length < 2) {
        return 'Gelieven minstens 2 karakters op te geven.'
      } else {
        return ''
      }
    },

    _escapeRegExp(str) {
      // eslint-disable-next-line
      return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    },

    formatWithXdecimals(value, X) {
      return parseFloat(parseFloat(value).toFixed(X))
    },

    _replaceAll(str, find, replace) {
      if (str !== undefined) {
        return str.replace(new RegExp(this._escapeRegExp(find), 'g'), replace);
      }
    },

    _removeSpecialChars(text) {
      return text.replace(/[^\w\s]/gi, '')
    },
    _isAlphanumeric(str) {
      return (
        str.length === 0 ||
        str.replace(/[^a-zA-Z0-9]/gi, '').length === str.length
      )
    },

    _onlyNumber($event) {
      // Numeriek veld controle waarbij enkel cijfers, decimaal teken of een comma toegelaten zijn
      // @keypress="_onlyNumber"
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 44 && keyCode !== 46 && keyCode !== 110 && keyCode !== 188) { // 46 is dot, 110 is decimal point, 188 is comma
        $event.preventDefault();
      }
    },

    _containsAlphabetic(str) {
      return (
        /[a-z]/.test(str.toLowerCase())
      )
    },

    _isAlphabetic(str) {
      return (
        str.length === 0 || str.replace(/[^a-zA-Z]/gi, '').length === str.length
      )
    },

    _occurrences: function(string, subString, allowOverlapping) {

      string += "";
      subString += "";
      if (subString.length <= 0) return (string.length + 1);

      var n = 0,
        pos = 0,
        step = allowOverlapping ? 1 : subString.length;

      // eslint-disable-next-line
      while (true) {
        pos = string.indexOf(subString, pos);
        if (pos >= 0) {
          ++n;
          pos += step;
        } else break;
      }
      return n;
    },

    _isString(str) {
      return typeof str === 'string'
    },
    _capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
    },
    _capitalizeFirstLetters(str) {
      if (this._isString(str)) {
        return str
          .split(' ')
          .map(this._capitalizeFirstLetter)
          .join(' ')
      }
      return ''
    },
    _isEmptyOrUngiven(str) {
      return (typeof str === 'undefined' || str === null || str === '' || str === 'undefined' || str === 'null')
    }
  }
}
